import { sanitizeUrl as sanitizeUrlBT } from '@braintree/sanitize-url';

export const classifyLink = (url: string, defaultType = 'website'): string => {
  if(
    /twitter/i.test(url) ||
    /t\.co/i.test(url) ||
    /https:\/\/x\.com/i.test(url) ||
    /https:\/\/www\.x\.com/i.test(url)
  ) return 'twitter';

  else if(
    /instagr\.am/i.test(url) ||
    /instagram\.com/i.test(url)
  ) return 'instagram';
  else if(/facebook\.com/i.test(url)) return 'facebook';
  else if(
    /youtube\.com/i.test(url) ||
    /youtu\.be/i.test(url) ||
    /youtube-nocookie\.com/i.test(url)
  ) return 'youtube';
  if(/linkedin\.com/i.test(url)) return 'linkedin';
  if(/tiktok\.com/i.test(url)) return 'tiktok';
  if(/bsky\.app/i.test(url) || /bsky\.social/i.test(url)) return 'bluesky';
  if(/threads\.net/i.test(url)) return 'threads';
  if(/youtube\.com/i.test(url)) return 'youtube';
  else return defaultType;
};

export const sanitizeUrl = (url: string, defaultHttp = false): string => {
  const appendProtocol = (url.startsWith('https://') || url.startsWith('http://'))
    ? url
    : (defaultHttp ? `http://${url}` : `https://${url}`);

  const safe = sanitizeUrlBT(appendProtocol);
  const urlObj = new URL(safe);

  return `${urlObj.href}`;
};

export const normalizeUrlForComparison = (url: string): string => {
  const trimmedUrl = String(url || '').trim().toLowerCase();
  if (!trimmedUrl) return '';

  try {
    const urlWithProtocol = /^https?:\/\//i.test(trimmedUrl)
      ? trimmedUrl
      : `https://${trimmedUrl}`;
    const parsedUrl = new URL(urlWithProtocol);
    const hostname = parsedUrl.hostname.replace(/^www\./, '');
    const pathname = parsedUrl.pathname.replace(/\/+$/, '');

    return `${hostname}${pathname}`;
  } catch (error) {
    return trimmedUrl
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .split(/[?#]/)[0]
      .replace(/\/+$/, '');
  }
};

export const areUrlsEquivalent = (url1: string, url2: string): boolean => {
  const normalizedUrl1 = normalizeUrlForComparison(url1);
  const normalizedUrl2 = normalizeUrlForComparison(url2);

  return Boolean(normalizedUrl1 && normalizedUrl2 && normalizedUrl1 === normalizedUrl2);
};

export const normalizeHostnameForComparison = (url: string): string => {
  const trimmedUrl = String(url || '').trim().toLowerCase();
  if (!trimmedUrl) return '';

  try {
    const urlWithProtocol = /^https?:\/\//i.test(trimmedUrl)
      ? trimmedUrl
      : `https://${trimmedUrl}`;

    return new URL(urlWithProtocol).hostname.replace(/^www\./, '');
  } catch (error) {
    return '';
  }
};

export const addRemovedLink = (removedLinks: string[] = [], url: string): string[] => {
  if (!url || removedLinks.some(removedLink => areUrlsEquivalent(removedLink, url))) {
    return removedLinks;
  }

  return [...removedLinks, url];
};

export const restoreRemovedLink = (removedLinks: string[] = [], url: string): string[] => (
  removedLinks.filter(removedLink => !areUrlsEquivalent(removedLink, url))
);

export const countEquivalentUrls = (
  url: string,
  links: Array<{ url?: string }> = []
): number => (
  links.filter(link => link.url && areUrlsEquivalent(url, link.url)).length
);

export const countEquivalentHostnames = (
  url: string,
  links: Array<{ url?: string }> = []
): number => {
  const hostname = normalizeHostnameForComparison(url);
  if (!hostname) return 0;

  return links.filter(link => (
    link.url && normalizeHostnameForComparison(link.url) === hostname
  )).length;
};
